import { PropsWithChildren } from 'react';

import { VariantProps, cva } from 'class-variance-authority';

export const baseVariants = cva(
  'tap-highlight-transparent w-full flex relative overflow-hidden items-center transition-all duration-200 ease-in-out',
  {
    variants: {
      variant: {
        default:
          'bg-base-300 hover:bg-hover-base-300-hover peer-focus:bg-hover-base-300-hover',
        /**
         * @deprecated use default variant.
         */
        send: 'bg-base-300 hover:bg-hover-base-300-hover peer-focus:bg-hover-base-300-hover',
        secondary:
          'bg-base-500 border border-transparent data-[is-invalid=false]:focus-within:ring-offset-background hover:border-carbon data-[is-invalid=false]:focus-within:border-primary-focus-border focus:border-primary-focus-border focus-within:hover:border-primary-focus-border data-[is-invalid=false]:focus-within:outline-0 data-[is-invalid=false]:focus-within:ring-offset-2 data-[disabled=true]:bg-base-500',
        /**
         * @deprecated use secondary variant.
         */
        dashboard:
          'bg-base-500 border border-transparent data-[is-invalid=false]:focus-within:ring-offset-background hover:border-carbon data-[is-invalid=false]:focus-within:border-primary-focus-border focus:border-primary-focus-border focus-within:hover:border-primary-focus-border data-[is-invalid=false]:focus-within:outline-0 data-[is-invalid=false]:focus-within:ring-offset-2 data-[disabled=true]:bg-base-500',
      },
      disabled: {
        true: 'opacity-50 cursor-not-allowed hover:border-transparent',
      },
      size: {
        default: 'h-[64px] px-[14px] py-[10px] rounded-[16px]',
        md: 'h-[50px] rounded-[10px] px-[14px] py-[7px]',
        sm: 'h-10 rounded-[12px] px-[6px] py-2',
      },
      isInvalid: {
        true: 'border-negative-500 hover:border-negative-500 focus-within:hover:border-negative-500',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
      isInvalid: false,
      disabled: false,
    },
  },
);

export interface IFloatingLabelClassNames {
  wrapper: string;
  content: string;
  placeholder: string;
  description: string;
}

export type TBaseVariants = VariantProps<typeof baseVariants>;

export interface IFloatingLabel
  extends TBaseVariants,
    React.ComponentProps<'label'> {
  placeholder?: string;
  description?: string;
  classNames?: Partial<IFloatingLabelClassNames>;
  className?: string;
  endContent?: React.ReactNode;
  startContent?: React.ReactNode;
  customPlaceholder?: string;
  triggerClassName?: string;
  isFocused: boolean;
}

export type TFloatingLabel = PropsWithChildren<IFloatingLabel>;
